export { default as withDetails } from './with-details';
